/* PiacerePuro Moderno — theme.js */
(function () {
  'use strict';

  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };
  var theme = window.theme || {};

  /* ---------- Formattazione prezzi ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;
    format = format || theme.moneyFormat || '€{{amount_with_comma_separator}}';
    function fmt(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      var n = (number / 100).toFixed(precision);
      var parts = n.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return parts[1] ? dollars + decimal + parts[1] : dollars;
    }
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount': value = fmt(cents, 2); break;
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': value = fmt(cents, 2, ' ', ','); break;
      default: value = fmt(cents, 2, '.', ',');
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }
  theme.formatMoney = formatMoney;

  /* ---------- Toast ---------- */
  var toastTimer;
  function toast(msg) {
    var el = $('#Toast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'Toast';
      el.className = 'toast';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
    }
    el.textContent = msg;
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 3200);
  }

  /* ---------- Drawer generici (menu, carrello, filtri) ---------- */
  var lastFocus = null;
  function openDrawer(drawer) {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    var focusable = $('[data-drawer-close], button, a, input', drawer);
    if (focusable) setTimeout(function () { focusable.focus(); }, 50);
    $$('[aria-controls="' + drawer.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
  }
  function closeDrawer(drawer) {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    $$('[aria-controls="' + drawer.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  theme.openDrawer = openDrawer;
  theme.closeDrawer = closeDrawer;

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      var target = document.getElementById(opener.getAttribute('data-drawer-open'));
      if (target) {
        e.preventDefault();
        openDrawer(target);
      }
      return;
    }
    var closer = e.target.closest('[data-drawer-close]');
    if (closer) {
      e.preventDefault();
      closeDrawer(closer.closest('.drawer'));
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    $$('.drawer.is-open').forEach(closeDrawer);
    var sm = $('.search-modal.is-open');
    if (sm) closeSearch();
    $$('.header__nav details[open]').forEach(function (d) { d.removeAttribute('open'); });
  });

  /* Chiudi i dropdown del menu cliccando fuori */
  document.addEventListener('click', function (e) {
    $$('.header__nav details[open]').forEach(function (d) {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });
  $$('.header__nav details').forEach(function (d) {
    d.addEventListener('mouseenter', function () { if (window.matchMedia('(hover: hover)').matches) d.setAttribute('open', ''); });
    d.addEventListener('mouseleave', function () { if (window.matchMedia('(hover: hover)').matches) d.removeAttribute('open'); });
  });

  /* ---------- Ricerca predittiva ---------- */
  function openSearch() {
    var m = $('#SearchModal');
    if (!m) return;
    m.classList.add('is-open');
    var input = $('input[type="search"]', m);
    if (input) setTimeout(function () { input.focus(); }, 30);
  }
  function closeSearch() {
    var m = $('#SearchModal');
    if (m) m.classList.remove('is-open');
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-search-open]')) { e.preventDefault(); openSearch(); }
    if (e.target.closest('[data-search-close]')) { e.preventDefault(); closeSearch(); }
  });

  var searchInput = $('#SearchModal input[type="search"]');
  var searchResults = $('#PredictiveResults');
  var searchTimer;
  if (searchInput && searchResults && theme.routes && theme.routes.predictive_search_url) {
    searchInput.addEventListener('input', function () {
      var q = searchInput.value.trim();
      clearTimeout(searchTimer);
      if (q.length < 2) { searchResults.innerHTML = ''; return; }
      searchTimer = setTimeout(function () {
        var url = theme.routes.predictive_search_url + '.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product,collection,article&resources[limit]=6&resources[options][unavailable_products]=last';
        fetch(url).then(function (r) { return r.json(); }).then(function (data) {
          var res = data.resources && data.resources.results ? data.resources.results : {};
          var html = '';
          (res.collections || []).forEach(function (c) {
            html += '<a href="' + c.url + '"><span style="width:56px;height:56px;border-radius:10px;background:var(--color-lilac);display:flex;align-items:center;justify-content:center;font-size:11px;font-weight:700">CAT</span><span>' + escapeHtml(c.title) + '</span></a>';
          });
          (res.products || []).forEach(function (p) {
            var img = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
            html += '<a href="' + p.url + '">' +
              (img ? '<img src="' + img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=120" alt="" loading="lazy">' : '<span style="width:56px;height:56px;border-radius:10px;background:var(--color-placeholder)"></span>') +
              '<span><span style="display:block;font-weight:600">' + escapeHtml(p.title) + '</span><span class="pr-price">' + formatMoney(Math.round(parseFloat(p.price) * 100)) + '</span></span></a>';
          });
          (res.articles || []).forEach(function (a) {
            html += '<a href="' + a.url + '"><span style="width:56px;height:56px;border-radius:10px;background:var(--color-sage);display:flex;align-items:center;justify-content:center;font-size:11px;font-weight:700">BLOG</span><span>' + escapeHtml(a.title) + '</span></a>';
          });
          if (!html) html = '<p style="color:var(--color-muted)">' + escapeHtml(searchResults.getAttribute('data-empty') || 'Nessun risultato') + '</p>';
          html += '<a href="/search?q=' + encodeURIComponent(q) + '&type=product" style="justify-content:center;font-weight:600;text-decoration:underline">' + escapeHtml(searchResults.getAttribute('data-all') || 'Vedi tutti i risultati') + '</a>';
          searchResults.innerHTML = html;
        }).catch(function () {});
      }, 250);
    });
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------- Carrello AJAX ---------- */
  var cartType = document.body.getAttribute('data-cart-type') || 'drawer';

  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = count > 0 ? count : ''; });
    $$('[data-cart-label]').forEach(function (el) {
      el.setAttribute('aria-label', (el.getAttribute('data-cart-label') || 'Carrello') + (count ? ', ' + count : ''));
    });
  }

  function renderCartDrawer(sectionsHtml) {
    if (!sectionsHtml || !sectionsHtml['cart-drawer']) return;
    var doc = new DOMParser().parseFromString(sectionsHtml['cart-drawer'], 'text/html');
    var fresh = doc.getElementById('CartDrawerPanel');
    var current = document.getElementById('CartDrawerPanel');
    if (fresh && current) {
      current.innerHTML = fresh.innerHTML;
      var count = parseInt(fresh.getAttribute('data-item-count'), 10) || 0;
      updateCartCount(count);
    }
  }

  function addToCart(items, button) {
    var original = button ? button.innerHTML : null;
    if (button) {
      button.setAttribute('aria-disabled', 'true');
      button.classList.add('is-loading');
      button.textContent = (theme.strings && theme.strings.adding) || 'Aggiunta…';
    }
    return fetch(theme.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items, sections: 'cart-drawer', sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, data: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.data.description || res.data.message || (theme.strings && theme.strings.cartError));
        if (cartType === 'page') { window.location.href = theme.routes.cart_url; return; }
        renderCartDrawer(res.data.sections);
        openDrawer(document.getElementById('CartDrawer'));
      })
      .catch(function (err) { toast(err.message || 'Errore'); })
      .finally(function () {
        if (button) {
          button.removeAttribute('aria-disabled');
          button.classList.remove('is-loading');
          button.innerHTML = original;
        }
      });
  }
  theme.addToCart = addToCart;

  function changeCart(line, quantity, container) {
    if (container) container.classList.add('is-loading');
    return fetch(theme.routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity, sections: 'cart-drawer', sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, data: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.data.description || res.data.message);
        if (document.body.classList.contains('template-cart')) { window.location.reload(); return; }
        renderCartDrawer(res.data.sections);
      })
      .catch(function (err) { toast(err.message || 'Errore'); if (container) container.classList.remove('is-loading'); });
  }

  /* Form prodotto: invio AJAX */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var idInput = form.querySelector('[name="id"]');
    var qtyInput = form.querySelector('[name="quantity"]');
    var btn = form.querySelector('[type="submit"]');
    if (!idInput || !idInput.value || (btn && btn.disabled)) return;
    addToCart([{ id: parseInt(idInput.value, 10), quantity: qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1 }], btn);
  });

  /* Aggiunta rapida dalle schede */
  document.addEventListener('click', function (e) {
    var quick = e.target.closest('[data-quick-add]');
    if (!quick) return;
    e.preventDefault();
    addToCart([{ id: parseInt(quick.getAttribute('data-quick-add'), 10), quantity: 1 }], quick);
  });

  /* Quantità (+/−) e rimozione nel carrello */
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-qty-step]');
    if (step) {
      var wrap = step.closest('.qty');
      var input = wrap && wrap.querySelector('input');
      if (!input) return;
      var delta = parseInt(step.getAttribute('data-qty-step'), 10);
      var min = parseInt(input.getAttribute('min') || '0', 10);
      var val = Math.max(min, (parseInt(input.value, 10) || 0) + delta);
      input.value = val;
      var line = input.getAttribute('data-line');
      if (line) changeCart(parseInt(line, 10), val, input.closest('.cart-item'));
      return;
    }
    var remove = e.target.closest('[data-cart-remove]');
    if (remove) {
      e.preventDefault();
      changeCart(parseInt(remove.getAttribute('data-cart-remove'), 10), 0, remove.closest('.cart-item'));
    }
  });
  document.addEventListener('change', function (e) {
    var input = e.target.closest('.qty input[data-line]');
    if (input) changeCart(parseInt(input.getAttribute('data-line'), 10), Math.max(0, parseInt(input.value, 10) || 0), input.closest('.cart-item'));
  });

  /* ---------- Varianti prodotto ---------- */
  $$('[data-product]').forEach(function (root) {
    var json = $('[data-product-json]', root);
    if (!json) return;
    var product;
    try { product = JSON.parse(json.textContent); } catch (err) { return; }
    var form = $('form[data-product-form]', root);
    var idInput = form && form.querySelector('[name="id"]');
    var btn = form && form.querySelector('[type="submit"]');
    var priceEl = $('[data-price]', root);
    var skuEl = $('[data-sku]', root);
    var stickyPrice = $('[data-sticky-price]');
    var stickyBtn = $('[data-sticky-atc]');

    function currentOptions() {
      return $$('.variant-group', root).map(function (g) {
        var checked = g.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }

    function priceHtml(v) {
      var html = '<span class="price__current">' + formatMoney(v.price) + '</span>';
      if (v.compare_at_price && v.compare_at_price > v.price) {
        html += '<s class="price__compare">' + formatMoney(v.compare_at_price) + '</s>';
        html += '<span class="price__save">' + (priceEl.getAttribute('data-save-label') || 'Risparmi') + ' ' + formatMoney(v.compare_at_price - v.price) + '</span>';
      }
      return html;
    }

    function update() {
      var opts = currentOptions();
      var variant = product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
      // segna le combinazioni non disponibili
      $$('.variant-group', root).forEach(function (g, gi) {
        $$('input', g).forEach(function (inp) {
          var test = opts.slice();
          test[gi] = inp.value;
          var match = product.variants.find(function (v) { return v.options.every(function (o, i) { return o === test[i]; }); });
          inp.classList.toggle('is-unavailable', !match || !match.available);
        });
      });
      if (!variant) {
        if (btn) { btn.disabled = true; btn.textContent = theme.strings.unavailable; }
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.innerHTML = priceHtml(variant);
      if (stickyPrice) stickyPrice.innerHTML = formatMoney(variant.price);
      if (skuEl) skuEl.textContent = variant.sku || '';
      if (btn) {
        btn.disabled = !variant.available;
        btn.textContent = variant.available ? theme.strings.addToCart : theme.strings.soldOut;
      }
      if (stickyBtn) {
        stickyBtn.disabled = !variant.available;
        stickyBtn.textContent = variant.available ? theme.strings.addToCart : theme.strings.soldOut;
      }
      if (variant.featured_media) goToMedia(root, variant.featured_media.id);
      if (window.history.replaceState && root.hasAttribute('data-update-url')) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    root.addEventListener('change', function (e) {
      if (e.target.closest('.variant-group')) update();
    });
    if ($$('.variant-group', root).length) update();

    if (stickyBtn && form) {
      stickyBtn.addEventListener('click', function () {
        if (typeof form.requestSubmit === 'function') form.requestSubmit(); else form.querySelector('[type="submit"]').click();
      });
    }
  });

  /* ---------- Galleria prodotto ---------- */
  function goToMedia(root, mediaId) {
    var slide = $('[data-media-id="' + mediaId + '"]', root);
    var slides = $('.gallery__slides', root);
    if (!slide || !slides) return;
    slides.scrollTo({ left: slide.offsetLeft - slides.offsetLeft, behavior: 'smooth' });
    setActiveThumb(root, mediaId);
  }
  function setActiveThumb(root, mediaId) {
    $$('.gallery__thumb', root).forEach(function (t) {
      t.setAttribute('aria-current', t.getAttribute('data-target') === String(mediaId) ? 'true' : 'false');
    });
  }
  $$('.gallery').forEach(function (gallery) {
    var root = gallery.closest('[data-product]') || gallery;
    var slides = $('.gallery__slides', gallery);
    var dots = $$('.gallery__dots span', gallery);
    $$('.gallery__thumb', gallery).forEach(function (t) {
      t.addEventListener('click', function () { goToMedia(root, t.getAttribute('data-target')); });
    });
    if (slides) {
      var tick;
      slides.addEventListener('scroll', function () {
        clearTimeout(tick);
        tick = setTimeout(function () {
          var idx = Math.round(slides.scrollLeft / slides.clientWidth);
          dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
          var slide = slides.children[idx];
          if (slide) setActiveThumb(root, slide.getAttribute('data-media-id'));
        }, 60);
      });
    }
  });

  /* ---------- Barra "aggiungi" fissa su mobile ---------- */
  var sticky = $('.sticky-atc');
  var mainAtc = $('[data-main-atc]');
  if (sticky && mainAtc && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var below = en.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', !en.isIntersecting && below);
      });
    }).observe(mainAtc);
  }

  /* ---------- Schede (tab) collezioni in evidenza ---------- */
  $$('[data-tabs]').forEach(function (wrap) {
    var tabs = $$('[role="tab"]', wrap);
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          var panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
      });
    });
  });

  /* ---------- Raccomandazioni prodotto ---------- */
  $$('[data-recommendations]').forEach(function (el) {
    var url = el.getAttribute('data-url');
    if (!url) return;
    fetch(url).then(function (r) { return r.text(); }).then(function (text) {
      var doc = new DOMParser().parseFromString(text, 'text/html');
      var fresh = doc.querySelector('[data-recommendations]');
      if (fresh && fresh.innerHTML.trim().length) el.innerHTML = fresh.innerHTML;
      else el.closest('.shopify-section') && (el.closest('.shopify-section').style.display = 'none');
    }).catch(function () {});
  });

  /* ---------- Filtri collezione: invio automatico ---------- */
  function submitFilters(form) {
    // non inviare i campi prezzo vuoti
    $$('input[type="number"]', form).forEach(function (i) { if (i.value === '') i.disabled = true; });
    form.submit();
  }
  $$('form[data-filter-form]').forEach(function (form) {
    form.addEventListener('change', function (e) {
      if (e.target.matches('input[type="checkbox"], select')) submitFilters(form);
    });
    form.addEventListener('submit', function (e) { e.preventDefault(); submitFilters(form); });
  });
  $$('select[data-sort]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  /* ---------- Barra annunci a rotazione su mobile ---------- */
  $$('.announcement__inner').forEach(function (bar) {
    var items = $$('.announcement__item', bar);
    if (items.length < 2) return;
    bar.classList.add('is-rotating');
    var i = 0;
    items[0].classList.add('is-visible');
    setInterval(function () {
      items[i].classList.remove('is-visible');
      i = (i + 1) % items.length;
      items[i].classList.add('is-visible');
    }, 4000);
  });

  /* ---------- Verifica età ---------- */
  var gate = $('#AgeGate');
  if (gate) {
    var key = 'pp_age_ok';
    var days = parseInt(gate.getAttribute('data-days'), 10) || 30;
    var ok = false;
    try {
      var stored = window.localStorage.getItem(key);
      ok = stored && Date.now() < parseInt(stored, 10);
    } catch (err) {
      ok = document.cookie.indexOf(key + '=1') > -1;
    }
    if (!ok) {
      gate.classList.add('is-open');
      document.documentElement.classList.add('age-locked');
      var yes = $('[data-age-yes]', gate);
      if (yes) setTimeout(function () { yes.focus(); }, 50);
    }
    gate.addEventListener('click', function (e) {
      if (e.target.closest('[data-age-yes]')) {
        try { window.localStorage.setItem(key, String(Date.now() + days * 864e5)); } catch (err) {
          document.cookie = key + '=1; max-age=' + days * 86400 + '; path=/; SameSite=Lax';
        }
        gate.classList.remove('is-open');
        document.documentElement.classList.remove('age-locked');
      }
    });
    gate.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var f = $$('a, button', gate);
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    });
  }
})();
